<script setup lang="ts">
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { toolkitUrls } from '@/util/links'
import { CONTENT_PAGE_EVENT_NAMES } from '@/goals/content_page_event_names'

const props = defineProps<{
  contentTitle: string
  contentUuid: string
  contentType: string
}>()

const PROGRESS_MONITORING_STRATEGY_SLUG = 'progress-monitoring'
const THUMBNAIL_URL = 'https://assets.goalbookapp.com/images/Progress+Monitoring+Thumbnail+(2).png'

const analytics = getAnalyticsTracker()
const progressMonitoringUrl = toolkitUrls.strategyPage(PROGRESS_MONITORING_STRATEGY_SLUG)

const trackLinkClicked = () => {
  analytics.sendEvent(
    CONTENT_PAGE_EVENT_NAMES.CLICKED_PROGRESS_MONITORING_LINK,
    { content_uuid: props.contentUuid, content_title: props.contentTitle, content_type: props.contentType },
    { cu: props.contentUuid, ct: props.contentTitle }
  )
}
</script>

<template>
  <div>
    <h2 class="mb-2.5 mt-9 text-display-sm font-medium leading-tight text-gray-900">Data Tracking Sheets</h2>
    <div class="flow-root rounded-xxs bg-yellow-100 p-2.5">
      <a
        :href="progressMonitoringUrl"
        target="_blank"
        class="group text-blue-400 hover:text-blue-500"
        data-testid="progress-monitoring-link"
        @click="trackLinkClicked"
      >
        <img :src="THUMBNAIL_URL" class="float-left mr-2 mt-1 h-16 w-20" alt="" />
        <h3 class="m-0 text-lg font-bold group-hover:underline">
          Progress Monitoring<span class="sr-only"> (Opens in a new tab)</span>
        </h3>
      </a>
      <p class="text-md">
        A teaching strategy page with a variety of printable data sheets to track progress on goals and objectives.
      </p>
    </div>
  </div>
</template>
